import React, { useContext } from "react";
import CaseStudyTemplatePage from "components/CaseStudyTemplate/CaseStudyTemplate";

import { useTranslation } from "react-i18next";
import { ColorModeContext } from "context/ColorModeContext";

import imgBanner from "assets/images/pages/inspect-master-banner.png";
import imgIdeas1 from "assets/images/pages/inspect-master/inspect-master_ideas2.jpg";
import imgIdeas2 from "assets/images/pages/inspect-master/inspect-master-ideas1.jpg";

import { PAGES } from "constants/pages";

import imgPersion1 from "assets/images/pages/home/clients/BP-Sasa.jpg";
import imgBusiness1 from "assets/images/pages/home/clients/BP Consulting_logo.png";
import Section from "components/Section/Section";

import Screen1 from "assets/images/pages/inspect-master/screen1.png";
import Screen2 from "assets/images/pages/inspect-master/screen2.png";
import Screen3 from "assets/images/pages/inspect-master/screen3.png";
import Screen4 from "assets/images/pages/inspect-master/screen4.png";
import Screen5 from "assets/images/pages/inspect-master/screen5.png";
import Image from "components/Image/Image";
import { ImageContainer } from "./CaseStudyInspectMaster.styled";
import useDevice from "hooks/useDevice";
const CaseStudyInspectMasterPage = () => {
  const { theme } = useContext(ColorModeContext);
  const { isMobile } = useDevice();

  const { t } = useTranslation();
  document.title = t(PAGES.CASE_STUDY_INSPECT_MASTER.title);
  const images = [Screen1, Screen2, Screen3, Screen4, Screen5];

  const data = {
    banner: {
      header: "caseStudies.inspectMaster.banner.header",
      text: "caseStudies.inspectMaster.banner.text",
      badges: t("caseStudies.inspectMaster.banner.badges", {
        returnObjects: true,
      }),
      image: imgBanner,
      imageObjectFit: "contain",
      highlightColor: theme.colors.thertiary,
    },
    stats: t("caseStudies.inspectMaster.stats", { returnObjects: true }),
    description: {
      header: "caseStudies.inspectMaster.description.header",
      pargarafs: [
        {
          image: imgIdeas1,
          text: "caseStudies.inspectMaster.description.paragrafs.paragraf1",
        },
        {
          image: imgIdeas2,
          text: "caseStudies.inspectMaster.description.paragrafs.paragraf2",
        },
      ],
    },
    businessChallenges: t("caseStudies.inspectMaster.businessChallenges", {
      returnObjects: true,
    }),
    ourSolutions: t("caseStudies.inspectMaster.ourSolutions", {
      returnObjects: true,
    }),
    theResults: {
      header: "caseStudies.inspectMaster.theResults.header",
      content: [
        {
          header: t(
            "caseStudies.inspectMaster.theResults.results.result1.text"
          ),
          imageText: t(
            "caseStudies.inspectMaster.theResults.results.result1.number"
          ),
          bgColor: "white",
        },
        {
          header: t(
            "caseStudies.inspectMaster.theResults.results.result2.text"
          ),
          imageText: t(
            "caseStudies.inspectMaster.theResults.results.result2.number"
          ),
          bgColor: "secondary",
        },
        {
          header: t(
            "caseStudies.inspectMaster.theResults.results.result3.text"
          ),
          imageText: t(
            "caseStudies.inspectMaster.theResults.results.result3.number"
          ),
          bgColor: "thertiary",
        },
      ],
    },
    sthForOur: {
      header: "caseStudies.inspectMaster.sthForOur.header",
      client: {
        personName: t(
          "caseStudies.inspectMaster.sthForOur.client.person.name"
        ),
        personPosition: t(
          "caseStudies.inspectMaster.sthForOur.client.person.position"
        ),
        message: t("caseStudies.inspectMaster.sthForOur.client.text"),
        personImg: imgPersion1,
        businessImg: imgBusiness1,
        businessImgHeight: "55px",
        businessImgHeightSm: "35px",
      },
    },
    moreStories: {
      title: t("caseStudies.inspectMaster.moreStories.header"),
      stories: t("caseStudies.inspectMaster.moreStories.stories", {
        returnObjects: true,
      }),
    },
  };
  return (
    <CaseStudyTemplatePage data={data}>
      <Section>
        <ImageContainer>
          {images.map((item, index) => (
            <Image
              key={index}
              image={item}
              width={isMobile ? "72px" : "180px"}
              height={"auto"}
              objectFit="contain"
            />
          ))}
        </ImageContainer>
      </Section>
    </CaseStudyTemplatePage>
  );
};

export default CaseStudyInspectMasterPage;
